import { keyframes } from '@emotion/react';
export const animations = {
  grow: keyframes`
    from {
     top: 50%;
     left: 50%;
     bottom: 50%;
     right: 50%;
    }

    to {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  `
};